import { isFunction, isObject } from 'lodash';

const isPromiseLike = (value: unknown) => {
  return isObject(value) && isFunction((value as any).then) && isFunction((value as any).catch);
};

/**
 * Helper method to determine if a value is classified as a Promise
 */
export const isPromise = <T = any>(value: unknown): value is Promise<T> => {
  return value instanceof Promise || isPromiseLike(value);
};
